import { IDIOMAS, useT } from './index';
import './selector.css';

/** Selector compacto ES | EN | PT. */
const SelectorIdioma = ({ className = '' }) => {
  const { lang, setLang } = useT();
  return (
    <div className={`p7-idioma ${className}`} role="group" aria-label="Idioma / Language / Idioma">
      {IDIOMAS.map((i) => (
        <button
          key={i.id}
          type="button"
          className={lang === i.id ? 'on' : ''}
          aria-pressed={lang === i.id}
          title={i.nombre}
          onClick={() => setLang(i.id)}
        >{i.corto}</button>
      ))}
    </div>
  );
};

export default SelectorIdioma;
